import { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import axios from 'axios';
import Swal from 'sweetalert2';
import { isTokenExpired } from '../js/global';
import { UserContext } from '../components/MyContext';

const Login = () => {

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [rememberMe, setRememberMe] = useState(false); 

  const navigate = useNavigate();
  const { setUserData } = useContext(UserContext);

  useEffect(() => {
    const token = localStorage.getItem(config.token_name) || sessionStorage.getItem(config.token_name);
    const savedEmail = localStorage.getItem('remembered_email');

    if (token) {
      if (isTokenExpired(token)) {
        localStorage.removeItem(config.token_name);
        sessionStorage.removeItem(config.token_name);

        if (savedEmail) {
          setEmail(savedEmail);
          setRememberMe(true);
        }
      } else {
        navigate('/');
      }
    } else {
      if (savedEmail) {
        setEmail(savedEmail);
        setRememberMe(true);
      }
    }
  }, [navigate]);

  const handlerLogin = async () => {
    try {
      const payload = {
        email: email,
        password: password,
        rememberMe: rememberMe,
      }

      const res = await axios.post(config.urlApi + '/users/login', payload)

      if (res.data.message === 'success') {
        Swal.fire({
          title: 'Sign In',
          icon: 'success',
          text: 'เข้าสู่ระบบเรียบร้อยแล้ว',
          timer: 1500,
          timerProgressBar: true
        })

        if (rememberMe) {
          localStorage.setItem(config.token_name, res.data.token);
          localStorage.setItem('remembered_email', email);
        } else {
          sessionStorage.setItem(config.token_name, res.data.token);
          localStorage.removeItem('remembered_email');
        }

        const userRes = await axios.get(config.urlApi + '/users/showUserApi', config.headers());

        if (userRes.status === 200) {
          const u = userRes.data.result;
          const userObj = {
            firstname: u.fname,
            surname: u.sname,
            roleName: u.role.role_name,
            facultyName: u.faculty.fac_name,
            campusName: u.faculty.campus.campus_name,
            facultyID: u.faculty.id,
            campusID: u.faculty.campus_id,
            latitude: u.faculty.latitude,
            longitude: u.faculty.longitude,
            logo: u.faculty.logo,
            email: u.email,
          };
          setUserData(userObj);

          localStorage.setItem('userData', JSON.stringify(userObj));
        }

        navigate('/');
      } else if (res.data.message === 'User not found') {
        Swal.fire({
          title: 'Sign In',
          icon: 'warning',
          text: 'ไม่พบข้อมูลในระบบ',
          timer: 2000,
          timerProgressBar: true
        })
      }
    } catch (e) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: 'ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง ',
      })
    }
  }

  const validateEmail = () => {
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const validatePassword = () => {
    if (password.length < 6) {
      setPasswordError('Password must be at least 6 characters');
    } else {
      setPasswordError('');
    }
  };

  return (
    <>
      <div
        className="app-auth-shell"
        style={{
          '--app-auth-bg-image': `url(${process.env.PUBLIC_URL}/img/bg.png)`
        }}
      >
        <section className="app-auth-card">
          <div className="app-auth-brand">
            <span>CMU Landscape</span>
            <h1>GHG Platform</h1>
            {/* <p>เข้าสู่ระบบเพื่อจัดการข้อมูลกิจกรรม มาตรการ และเอกสารใน workspace เดียวกับระบบ backend</p> */}
          </div>
          <div className="mb-3 login-wrap p-0 signin-form">
            <label>Username</label>
            <input
              type='email'
              className='form-control p-3 shadow-sm'
              placeholder='email@email.com'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={validateEmail}
            />
            {emailError && <p className='text-danger mt-2'>{emailError}</p>}
          </div>
          <div className="mb-3">
            <label>Password</label>
            <input
              type='password'
              required
              className='form-control p-3 shadow-sm'
              placeholder='Password'
              onChange={(e) => setPassword(e.target.value)}
              onBlur={validatePassword}
            />
            {passwordError && <p className='text-danger mt-2'>{passwordError}</p>}
          </div>

          <div className="mb-3 form-check d-flex align-items-center">
            <input
              type="checkbox"
              className="form-check-input"
              id="rememberMe"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="rememberMe">
              Remember me
            </label>
          </div>

          {email && password !== '' ? <button className='form-control btn btn-primary submit px-3' onClick={handlerLogin}>
            เข้าสู่ระบบ
          </button>
            : <button className='btn form-control btn-primary submit px-3' disabled>
              เข้าสู่ระบบ
            </button>}
          <div className="app-auth-footer">Copyright © CMU 2026</div>
        </section>
      </div>
    </>
  );
}

export default Login;
